import { PHONE, locationSchema } from "../structured-data-core";

export function getRaleighStructuredData() {
  const url = "https://restorehair.com/locations/north-carolina/raleigh/";
  const description =
    "Find out about your hair transplant options in Raleigh with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Raleigh", "4509 Creedmoor Rd, Suite 201", "Raleigh", "NC", PHONE, url, description),
  ];
}
